import { useEffect, useState, useContext } from "react";
import axios from "axios";
import AquaButton from "../../main/app-download/AquaButton";
import closeIcon from "../../../assets/icons/close.png";
import { AuthContext } from "../../layout/AuthContext";
import { Link } from "react-router-dom";
import LoginModal from "../LoginModal";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar } from "swiper/modules";

import "swiper/css";
import "swiper/css/scrollbar";

const ChooseTimeModal = ({
  doctorId,
  officeId,
  name,
  speciality,
  address,
  imgUrl,
  isOpen,
  onClose,
}) => {
  const [days, setDays] = useState([]);
  const [loadingDays, setLoadingDays] = useState(false);

  const [times, setTimes] = useState([]);
  const [loadingTimes, setLoadingTimes] = useState(false);

  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTimeId, setSelectedTimeId] = useState(null);

  const { isLogged, loading } = useContext(AuthContext);

  const [loginText, setLoginText] = useState("");
  const [redirectAddres, setRedirectAddress] = useState("");

  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [errorText, setErrorText] = useState("");

  const isConfirmDisabled = !selectedDay || !selectedTimeId;

  const fetchDays = async () => {
    setLoadingDays(true);
    setErrorText("");
    try {
      const response = await axios.post(
        "https://medizenapi.ir/v1/appointment/getAppointments",
        { doctor_id: doctorId, office_id: officeId }
      );
      setDays(Array.isArray(response?.data?.data) ? response.data.data : []);
    } catch (error) {
      console.error("Error fetching days:", error);
      setErrorText("امکان دریافت روزهای نوبت‌دهی وجود ندارد.");
    } finally {
      setLoadingDays(false);
    }
  };

  const fetchTimes = async (jalali_date, appointmentId) => {
    setLoadingTimes(true);
    setSelectedDay(jalali_date);
    setSelectedTime(null);
    setSelectedTimeId(null);
    setErrorText("");

    try {
      const response = await axios.post(
        "https://medizenapi.ir/v1/appointment/getAppointmentTime",
        {
          doctor_id: doctorId,
          office_id: officeId,
          appointment_id: appointmentId,
        }
      );
      setTimes(Array.isArray(response?.data?.data) ? response.data.data : []);
    } catch (error) {
      console.error("Error fetching times:", error);
      setErrorText("امکان دریافت ساعت‌های نوبت‌دهی وجود ندارد.");
      setTimes([]);
    } finally {
      setLoadingTimes(false);
    }
  };

  useEffect(() => {
    if (isOpen && doctorId && officeId) {
      fetchDays();
    }
  }, [isOpen, doctorId, officeId]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      setSelectedDay(null);
      setSelectedTime(null);
      setSelectedTimeId(null);
      setDays([]);
      setTimes([]);
      setOpenLoginModal(false);
      setErrorText("");
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const loginCheck = (time, timeId) => {
    setSelectedTime(time);
    setSelectedTimeId(timeId);
  };

  const closeLoginModal = () => {
    setOpenLoginModal(false);
  };

  const handleContinue = () => {
    if (loading || isConfirmDisabled) return;

    if (isLogged) {
      window.location.href = `https://medizen.ir/panel/panel/?m=applet&sub=add_appointment&apid=${selectedTimeId}`;
      return;
    }

    setOpenLoginModal(true);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50">
        {/* Main modal container - using flex column to separate header and content */}
        <div
          className="relative bg-white shadow-2xl rounded-[15px] z-50 flex flex-col max-h-[90%] w-[90%] md:w-[70%] overflow-hidden" // Added overflow-hidden here to contain flex items
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header - This part will remain fixed */}
          <div className="flex justify-between items-center border-b-2 py-4 md:pb-5 md:pt-6 px-5 md:px-7 bg-white z-10"> {/* Added px for consistent padding, bg-white and z-10 to ensure it stays above scrolled content */}
            <span className="text-[18px] md:text-[22px] font-semibold">
              ثبت نوبت حضوری
            </span>
            <button
              className="bg-gray-100 rounded-[50%] w-[44px] h-[44px] flex justify-center items-center"
              onClick={onClose}
            >
              <img src={closeIcon} alt="Close" className="w-[15px]" />
            </button>
          </div>

          {/* Modal Content - This part will scroll */}
          <div className="flex-grow overflow-y-auto p-5 md:p-7"> {/* flex-grow makes it take available space, overflow-y-auto enables scrolling */}
            <div className="flex flex-col gap-7"> {/* Wrapper for content inside the scrollable area */}

              {/* Doctor Info Section */}
              <div className="flex flex-col sm:flex-row gap-5 items-center">
                <div className="w-full flex justify-center sm:w-fit">
                  <img
                    src={imgUrl}
                    alt={name}
                    className="rounded-full w-[100px] h-[100px] min-w-[100px] object-cover"
                  />
                </div>
                <div className="text-center sm:text-right flex flex-col gap-1">
                  <span className="font-medium text-[17px] md:text-[20px]">
                    {name}
                  </span>
                  <span className="text-[15px] md:text-[17px] opacity-80">
                    {speciality}
                  </span>
                  <span className="text-[13px] md:text-[16px] opacity-60">
                    <span>آدرس مطب: </span>
                    <span>{address}</span>
                  </span>
                </div>
              </div>

              {!!errorText && (
                <p className="w-full text-center text-red-600 text-[14px]">
                  {errorText}
                </p>
              )}

              {loadingDays && (
                <p className="w-full py-2 text-center">در حال بارگذاری روزها...</p>
              )}

              {!loadingDays && days.length > 0 && (
                <div className="flex flex-col w-full overflow-hidden">
                  <span className="font-medium text-[16px] md:text-[19px]">روز</span>
                  <Swiper
                    modules={[FreeMode, Scrollbar]}
                    spaceBetween={12}
                    slidesPerView="auto"
                    freeMode
                    className="mt-3 w-full pb-3"
                  >
                    {days.map((day) => (
                      <SwiperSlide key={day.jalali_date} style={{ width: "120px" }}>
                        {day.status === "active" ? (
                          <button
                            onClick={() => fetchTimes(day.jalali_date, day.id)}
                            className={`w-full text-[15px] md:text-[17px] px-2 rounded-[10px] py-4 border-2 transition-colors
                            ${
                              selectedDay === day.jalali_date
                                ? "border-aqua bg-aqua bg-opacity-10 text-aqua"
                                : "border-gray-300 hover:border-gray-400"
                            }`}
                          >
                            <div className="font-medium flex flex-col items-center gap-1">
                              <span className="text-[20px] font-bold">
                                {day.jalali_date.split("/")[2].replace(/^0/, "")}
                              </span>
                              <span className="whitespace-nowrap text-[13px] md:text-[14px]">
                                {day.shamsi_month_name} {day.jalali_date.split("/")[0]}
                              </span>
                            </div>
                            <span className="text-aqua text-[13px] mt-1 block">
                              {day.count} نوبت
                            </span>
                          </button>
                        ) : (
                          <button
                            disabled
                            className="w-full text-[15px] md:text-[17px] px-2 rounded-[10px] py-4 bg-[#F2F2F2] text-[#444444] text-opacity-40 cursor-not-allowed"
                          >
                            <div className="font-medium flex flex-col items-center gap-1">
                              <span className="text-[20px] font-bold">
                                {day.jalali_date.split("/")[2].replace(/^0/, "")}
                              </span>
                              <span className="whitespace-nowrap text-[13px] md:text-[14px]">
                                {day.shamsi_month_name} {day.jalali_date.split("/")[0]}
                              </span>
                            </div>
                            <span className="text-aqua text-[13px] text-opacity-50 mt-1 block">
                              {day.count} نوبت
                            </span>
                          </button>
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              )}

              {loadingTimes && (
                <p className="w-full py-2 text-center">در حال بارگذاری ساعت‌ها...</p>
              )}

              {!loadingTimes && selectedDay && times.length > 0 && (
                <div className="flex flex-col ">
                  <h3 className="font-medium text-[16px] md:text-[19px]">ساعت</h3>
                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3 mt-3">
                    {times.map((time) =>
                      time.status === "open" ? (
                        <button
                          key={time.id ?? time.time}
                          onClick={() => loginCheck(time.time, time.id)}
                          className={`border-2 rounded-[10px] py-2 text-[15px] md:text-[17px] transition-colors
                          ${
                            selectedTime === time.time
                              ? "border-aqua bg-aqua bg-opacity-10 text-aqua"
                              : "border-gray-300 hover:border-gray-400"
                          }`}
                        >
                          {time.time.slice(0, 5)}
                        </button>
                      ) : (
                        <button
                          disabled
                          key={time.id ?? time.time}
                          className="rounded-[10px] py-2 text-[15px] md:text-[17px] bg-[#F2F2F2] text-[#444444] text-opacity-30 cursor-not-allowed"
                        >
                          {time.time.slice(0, 5)}
                        </button>
                      )
                    )}
                  </div>
                </div>
              )}

              <div className="w-full flex justify-center mt-2">
                <Link
                  to={redirectAddres}
                  className="font-semibold text-[18px] underline text-aqua"
                >
                  {loginText}
                </Link>
              </div>

              <div className="w-full flex flex-col gap-3">
                <AquaButton
                  text={"تایید و ادامه"}
                  width={"w-full"}
                  height={"h-[50px]"}
                  disabled={isConfirmDisabled ? "disabled" : ""}
                  onClick={handleContinue}
                />
              </div>

            </div> {/* End of content wrapper */}
          </div> {/* End of scrollable content area */}
        </div> {/* End of main modal container */}
      </div>

      {openLoginModal ? (
        <LoginModal timeId={selectedTimeId} onClose={closeLoginModal} />
      ) : (
        ""
      )}
    </>
  );
};

export default ChooseTimeModal;
